<template>
  <DrillDownColumn
    :hcTitle="apiData ? apiData.title : null"
    :hcSubtitle="apiData ? apiData.last_update : null"
    :series="apiData ? apiData.chart_data.data.series_data : []"
    :drilldown="apiData ? apiData.chart_data.data.drilldown : {}"
  />
</template>

<script>
// import StackedChart from "@/components/charts/highcharts/StackedColumnChart.vue";
import DrillDownColumn from "@/components/charts/highcharts/DrillDownColumnChart.vue";
import RedElectricaAPI from "@/api/red-electrica.js";

export default {
  //   props: ["apiData"],
  components: { DrillDownColumn }, // StackedChart
  data() {
    return {
      apiData: null,
      apiResponse: null,
      queryParams: {
        lang: "en",
        category: "balance",
        widget: "balance-electrico",
        start_date: "2021-02-01",
        end_date: new Date().toISOString().slice(0, 10),
        time_trunc: "month",
        geo_trunc: null,
        geo_limit: null,
        geo_ids: null,
        data_format: "drilldown",
      },
    };
  },
  methods: {
    getApiData() {
      RedElectricaAPI.get(this.queryParams)
        .then((response) => {
          this.apiData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {},
  mounted() {
    this.getApiData();
  },
};
</script>

<style scoped>
.chart-container {
  width: 80%;
  height: 80%;
}
</style>
